import React from 'react';

export const DynamicNumber: React.FC<{
  number: number;
  color?: string;
  className?: string;
}> = ({
  number,
  color = 'var(--icon-color, var(--primary-color))',
  className,
}) => {
  const numberStr = number.toString().padStart(2, '0');
  
  // Setting fixed dimensions to ensure consistent sizing
  const fixedWidth = 110;
  const fixedHeight = 60;

  return (
    <svg
      width={fixedWidth}
      height={fixedHeight}
      viewBox={`0 0 ${fixedWidth} ${fixedHeight}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <text
        x="50%"
        y="50%"
        dominantBaseline="middle"
        textAnchor="middle"
        fontSize="48"
        fontFamily="Arial, sans-serif"
        fontWeight="bold"
        fill={color}
        letterSpacing="0px"
      >
        {numberStr}
      </text>
    </svg>
  );
};
